// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"d0f88271","167":"85965e72","351":"d118384d","666":"9b74bca3","727":"0de00d55","747":"d18d9847","955":"9a972faf","982":"30845951"}[chunkId] + ".chunk.js";
};